import { mediaStore, TABLES } from './store/media.store';
import { ISyncOptions } from '@/utils/ISyncOptions';
import { messageService } from '@/utils/MessageService';
import { sync, syncOperation, PersistentStore } from '@/utils/PersistentStore';
import { mediaService } from './services/mediaService';


async function doSync() {
  await sync<server.mediaDetail>(TABLES.media,
    i => {
      return i.id < 0 ? syncOperation.create : syncOperation.noop
    },
    async i => {
      return i
    },
    i => mediaService.Upload(i as server.mediaUpload))
}

export default {
  preStartup: async (): Promise<void> => {
    messageService.subscribe('syncMedia', async (messages: messages.syncMedia[] | messages.syncMedia) => {
      if (Array.isArray(messages))
        await Promise.all(messages.map(m => mediaStore.getters.get(m.typeId, m.type)))
      else
        await mediaStore.getters.get(messages.typeId, messages.type)
    });

    messageService.subscribe('updateMediaReference', async (message: messages.updateMediaReference) => {
      if (message.newTypeId == message.oldTypeId) return;

      var result = (await PersistentStore.getAll<server.mediaDetail>(TABLES.media)).filter(i => i.type == message.type && i.typeId == message.oldTypeId);
      for (const m of result) {
        m.typeId = message.newTypeId;
        m['__needsSync'] = true;
      }

      await PersistentStore.set(TABLES.media, result);
      await doSync();
    })

  },
  startup: async (): Promise<void> => {
    console.log('startup', 'media sync');
  },
  syncOperations: doSync
} as ISyncOptions;